/* =========================================================
   INDILOOM THEME | global.js  (vanilla, deferred, no dependencies)
   ========================================================= */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var CFG = {};
  try { CFG = JSON.parse($('#il-config').textContent); } catch (e) {}
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isDesk = window.matchMedia('(min-width: 1024px)');
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* ---------- Money ---------- */
  function money(cents) {
    var fmt = CFG.moneyFormat || '₹{{amount}}';
    var n = (Number(cents) || 0) / 100;
    function f(v, d, t, dec) { var p = v.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return p.join(dec); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return f(n, 0, ',', '.');
        case 'amount_with_comma_separator': return f(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return f(n, 0, '.', ',');
        default: return f(n, 2, ',', '.');
      }
    });
  }
  window.ilMoney = money;

  /* ---------- Toast ---------- */
  var toastEl = $('#il-toast'), toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-show');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-show'); }, 2400);
  }
  window.ilToast = toast;

  /* ---------- Header shrink on scroll (the mobile tab bar always stays in view) ---------- */
  var header = $('.il-header');
  var ticking = false;
  function onScroll() {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 60);
    ticking = false;
  }
  window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });
  onScroll();

  /* ---------- Panels: drawers + search ---------- */
  /* The category drawer is output by the header section, whose sticky stacking context sits
     below the page overlay. Move it to <body> so it always shows above the overlay. */
  function hoistMenu() {
    var all = $$('[id="il-menu"]'), fresh = all.filter(function (x) { return x.parentNode !== document.body; });
    if (!fresh.length) return;
    all.forEach(function (x) { if (x.parentNode === document.body) x.remove(); });
    document.body.appendChild(fresh[0]);
  }
  hoistMenu();
  var overlay = $('#il-overlay');
  var current = null, lastFocus = null;
  function setExpanded(id, v) { $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', v); }); }
  function openPanel(id) {
    var el = document.getElementById(id);
    if (!el) return false;
    if (el.hasAttribute('data-hoist') && el.parentNode !== document.body) document.body.appendChild(el); /* drawers inside sticky blocks open at page level */
    if (current && current !== el) closePanel(true);
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.documentElement.classList.add('il-lock');
    setExpanded(id, 'true');
    current = el;
    $$('img.il-lzy[data-src]:not(.il-lzy--hover)', el).forEach(showImg); /* drawer images start loading as it opens */
    var f = $('[data-autofocus]', el) || $('button, a, input', el);
    setTimeout(function () { if (f) f.focus({ preventScroll: true }); }, 60);
    return true;
  }
  function closePanel(silent) {
    if (!current) return;
    current.classList.remove('is-open');
    current.setAttribute('aria-hidden', 'true');
    setExpanded(current.id, 'false');
    if (overlay) overlay.classList.remove('is-open');
    document.documentElement.classList.remove('il-lock');
    current = null;
    if (!silent && lastFocus) lastFocus.focus({ preventScroll: true });
  }
  window.ilOpen = openPanel;
  window.ilClose = closePanel;
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { if (openPanel(o.getAttribute('data-open'))) e.preventDefault(); return; }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closePanel(); }
  });
  if (overlay) overlay.addEventListener('click', function () { closePanel(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePanel();
    if (e.key === 'Tab' && current) {
      var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', current).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* =========================================================
     FIRST INTERACTION
     Motion (rotators, hero autoplay) waits for the first real
     user input so the page settles fast and stays visually stable.
     ========================================================= */
  var interactQ = [], interacted = false;
  function afterInteract(fn) { if (interacted) fn(); else interactQ.push(fn); }
  function fireInteract() {
    if (interacted) return; interacted = true;
    ['pointerdown', 'keydown', 'touchstart', 'wheel', 'mousemove', 'scroll'].forEach(function (ev) { window.removeEventListener(ev, fireInteract, true); });
    interactQ.splice(0).forEach(function (fn) { try { fn(); } catch (e) {} });
  }
  ['pointerdown', 'keydown', 'touchstart', 'wheel', 'mousemove', 'scroll'].forEach(function (ev) { window.addEventListener(ev, fireInteract, { capture: true, passive: true }); });
  window.ilAfterInteract = afterInteract;

  /* =========================================================
     RAZORPAY MAGIC CHECKOUT
     The script is loaded after the first interaction (setting "rzp": "interaction").
     If a checkout button is pressed before it has loaded, the click waits for the
     script and is then replayed, so Razorpay still opens. If Razorpay does not take
     over, the button simply submits to the Shopify checkout.
     ========================================================= */
  var RZP_SRC = 'https://magic-plugins.razorpay.com/shopify/magic-shopify.js';
  var rzpState = CFG.rzp === 'page' ? 2 : 0, rzpQ = [];
  function loadRzp(cb) {
    if (cb) rzpQ.push(cb);
    if (rzpState === 2) { rzpQ.splice(0).forEach(function (f) { f(); }); return; }
    if (rzpState === 1) return;
    rzpState = 1;
    var sc = document.createElement('script');
    sc.src = RZP_SRC; sc.crossOrigin = 'anonymous';
    var done = function () { rzpState = 2; setTimeout(function () { rzpQ.splice(0).forEach(function (f) { f(); }); }, 350); };
    sc.onload = done; sc.onerror = done;
    document.body.appendChild(sc);
  }
  if (CFG.rzp === 'interaction') {
    afterInteract(function () { loadRzp(); });
    document.addEventListener('click', function (e) {
      if (rzpState === 2) return;
      var b = e.target.closest && e.target.closest('[name="checkout"], a[href$="/checkout"]');
      if (!b) return;
      e.preventDefault(); e.stopImmediatePropagation();
      b.classList.add('is-loading');
      loadRzp(function () { b.classList.remove('is-loading'); b.click(); });
    }, true);
  }
  /* Used by "Buy it now": opens Razorpay (or the Shopify checkout) for the cart */
  window.ilCheckout = function () {
    var go = document.querySelector('[data-rzp-go]');
    if (CFG.rzp && go) { loadRzp(function () { go.click(); }); return; }
    window.location.href = (CFG.root || '/') + 'checkout';
  };

  /* ---------- Google Merchant Center store widget (after first interaction) ---------- */
  if (CFG.merchantWidget) afterInteract(function () {
    var sc = document.createElement('script');
    sc.src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js'; sc.defer = true;
    sc.onload = function () { try { window.merchantwidget.start({ position: 'RIGHT_BOTTOM', mobileBottomMargin: 84 }); } catch (e) {} };
    document.body.appendChild(sc);
  });

  /* =========================================================
     LAZY IMAGES
     il-image renders defer:'view' and defer:'hover' images with
     data-src/data-srcset. View images load as they scroll into
     view (also inside horizontal sliders, which native lazy
     loading fetches all at once); hover images load on first hover.
     ========================================================= */
  function showImg(img) {
    if (!img || !img.hasAttribute('data-srcset') && !img.hasAttribute('data-src')) return;
    var pic = img.parentNode;
    if (pic && pic.tagName === 'PICTURE') $$('source[data-srcset]', pic).forEach(function (s) { s.srcset = s.getAttribute('data-srcset'); s.removeAttribute('data-srcset'); });
    if (img.getAttribute('data-srcset')) img.srcset = img.getAttribute('data-srcset');
    if (img.getAttribute('data-src')) img.src = img.getAttribute('data-src');
    img.removeAttribute('data-srcset'); img.removeAttribute('data-src');
  }
  var lio = 'IntersectionObserver' in window ? new IntersectionObserver(function (en) {
    en.forEach(function (x) { if (x.isIntersecting) { lio.unobserve(x.target); showImg(x.target); } });
  }, { rootMargin: '320px 0px' }) : null;
  function ilLazy(scope) {
    $$('img.il-lzy[data-src]:not(.il-lzy--hover)', scope).forEach(function (img) {
      if (img.ilLz) return; img.ilLz = true;
      lio ? lio.observe(img) : showImg(img);
    });
  }
  window.ilLazy = ilLazy;
  /* A slider being scrolled loads the rest of its images */
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || t === document || t.ilAll || !t.querySelectorAll) return;
    t.ilAll = true;
    $$('img.il-lzy[data-src]:not(.il-lzy--hover)', t).forEach(showImg);
  }, { capture: true, passive: true });
  /* Card second image on first hover or keyboard focus */
  function hoverImg(e) {
    var c = e.target.closest && e.target.closest('.il-card');
    if (c && !c.ilHov) { c.ilHov = true; showImg($('img.il-lzy--hover', c)); }
  }
  if (window.matchMedia('(hover:hover)').matches) document.addEventListener('pointerover', hoverImg, { passive: true });
  document.addEventListener('focusin', hoverImg);
  ilLazy(document);

  /* ---------- Rotators ---------- */
  afterInteract(function () {
    $$('[data-rotate]').forEach(function (wrap) {
      var items = $$('[data-rotate-item]', wrap);
      if (items.length < 2 || reduceMotion) return;
      var i = 0, ms = +wrap.getAttribute('data-rotate') || 4500;
      setInterval(function () { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, ms);
    });
    var hints = (CFG.hints || []).map(function (h) { return h.trim(); }).filter(Boolean), hintEls = $$('[data-hint]');
    if (hints.length > 1 && hintEls.length && !reduceMotion) {
      var hi = 0;
      setInterval(function () { hi = (hi + 1) % hints.length; hintEls.forEach(function (el) { el.textContent = hints[hi]; }); }, 2600);
    }
  });

  /* ---------- Hero: mobile carousel dots + autoplay ---------- */
  $$('[data-hero]').forEach(function (hero) {
    var dots = $$('span', hero.parentNode.querySelector('[data-hero-dots]') || document.createElement('div'));
    var slides = Array.prototype.slice.call(hero.children);
    if (slides.length < 2) return;
    var idx = 0, t;
    function sync() {
      var x = hero.scrollLeft, best = 0, bd = 1e9;
      slides.forEach(function (s, n) { var d = Math.abs(s.offsetLeft - slides[0].offsetLeft - x); if (d < bd) { bd = d; best = n; } });
      idx = best;
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === best); });
    }
    hero.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
    function next() { if (isDesk.matches) return; var n = (idx + 1) % slides.length; hero.scrollTo({ left: slides[n].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' }); }
    function play() { clearInterval(t); if (!reduceMotion && hero.hasAttribute('data-autoplay')) t = setInterval(next, +hero.getAttribute('data-autoplay') || 5000); }
    hero.addEventListener('touchstart', function () { clearInterval(t); }, { passive: true });
    hero.addEventListener('touchend', play, { passive: true });
    afterInteract(function () {
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { en[0].isIntersecting ? play() : clearInterval(t); }).observe(hero);
    });
  });

  /* ---------- Tabs ---------- */
  /* Inactive tab panels ship their cards in <template data-tab-tpl> */
  function fillTab(p) {
    var tpl = $('template[data-tab-tpl]', p);
    if (!tpl) return;
    p.replaceChild(tpl.content, tpl);
    ilLazy(p); wishPaint();
  }
  function initTabs(scope) {
    $$('[data-tabs]', scope).forEach(function (wrap) {
      if (wrap.ilTabs) return; wrap.ilTabs = true;
      var tabs = $$('[role="tab"]', wrap);
      function select(tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1;
          var p = document.getElementById(t.getAttribute('aria-controls'));
          if (p && on) fillTab(p);
          if (p) { p.hidden = !on; if (on) { p.classList.remove('il-fade'); void p.offsetWidth; p.classList.add('il-fade'); } }
        });
        var link = $('[data-tabs-link]', wrap);
        if (link && tab.getAttribute('data-url')) link.href = tab.getAttribute('data-url');
        initRails(wrap);
      }
      tabs.forEach(function (t, n) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('pointerenter', function () { var p = document.getElementById(t.getAttribute('aria-controls')); if (p) fillTab(p); }, { once: true });
        t.addEventListener('keydown', function (e) {
          var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (k) { var nx = tabs[(n + k + tabs.length) % tabs.length]; nx.focus(); select(nx); }
        });
      });
    });
  }

  /* ---------- Rail arrows ---------- */
  function initRails(scope) {
    $$('[data-rail]', scope).forEach(function (rail) {
      var prev = $('[data-prev="' + rail.id + '"]'), next = $('[data-next="' + rail.id + '"]');
      if (!prev || !next) return;
      function update() {
        prev.disabled = rail.scrollLeft <= 4;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
      }
      if (!rail.ilRail) {
        rail.ilRail = true;
        prev.addEventListener('click', function () { rail.scrollBy({ left: -rail.clientWidth * 0.9, behavior: 'smooth' }); });
        next.addEventListener('click', function () { rail.scrollBy({ left: rail.clientWidth * 0.9, behavior: 'smooth' }); });
        rail.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
        window.addEventListener('resize', update);
      }
      requestAnimationFrame(update);
    });
  }
  initTabs(document); initRails(document);

  /* ---------- Share buttons (snippets/il-share.liquid) ---------- */
  if (navigator.share) $$('[data-share-native]').forEach(function (b) { b.hidden = false; });
  document.addEventListener('click', function (e) {
    var n = e.target.closest('[data-share-native]'), c = e.target.closest('[data-copy-url]');
    if (n && navigator.share) { navigator.share({ title: n.getAttribute('data-title') || document.title, url: n.getAttribute('data-url') || location.href }).catch(function () {}); }
    if (c) {
      var done = function () { c.classList.add('is-done'); toast('Link copied'); setTimeout(function () { c.classList.remove('is-done'); }, 1600); };
      if (navigator.clipboard) navigator.clipboard.writeText(c.getAttribute('data-copy-url') || location.href).then(done, done); else done();
    }
  });

  /* ---------- Copy coupon ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]');
    if (!b) return;
    var code = b.getAttribute('data-copy'), label = b.textContent;
    var done = function () { b.classList.add('is-done'); b.textContent = 'Copied'; toast(code + ' copied'); setTimeout(function () { b.classList.remove('is-done'); b.textContent = label; }, 1800); };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
  });

  /* ---------- Wishlist (stored in this browser) ---------- */
  var WKEY = 'il-wishlist';
  function wishList() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function wishSave(l) { try { localStorage.setItem(WKEY, JSON.stringify(l)); } catch (e) {} }
  function wishPaint() {
    var l = wishList();
    $$('[data-wish]').forEach(function (b) { b.setAttribute('aria-pressed', l.indexOf(b.getAttribute('data-wish')) > -1 ? 'true' : 'false'); });
    $$('[data-wish-count]').forEach(function (c) { c.textContent = l.length; c.hidden = !l.length; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wish'), l = wishList(), i = l.indexOf(h);
    if (i > -1) { l.splice(i, 1); toast('Removed from wishlist'); } else { l.unshift(h); toast('Saved to wishlist'); }
    wishSave(l.slice(0, 100)); wishPaint();
  });
  wishPaint();
  window.ilWishList = wishList;
  window.ilWishPaint = wishPaint;

  /* ---------- Footer columns: accordion on mobile, open on desktop ---------- */
  function footerCols() { $$('[data-fcol]').forEach(function (d) { d.open = isDesk.matches; }); }
  footerCols();
  if (isDesk.addEventListener) isDesk.addEventListener('change', footerCols);

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-step]');
    if (!b) return;
    var input = b.parentNode.querySelector('input[type="number"]');
    if (!input) return;
    var min = +input.min || 0, max = +input.max || 999;
    input.value = Math.max(min, Math.min(max, (parseInt(input.value, 10) || 0) + (+b.getAttribute('data-step'))));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* =========================================================
     CART  (AJAX API + Section Rendering API)
     ========================================================= */
  var SECTION = 'cart-drawer';
  function hasDrawer() { return CFG.cartType === 'drawer' && !!document.getElementById('il-cart'); }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (c) {
      c.textContent = n; c.hidden = !(+n);
      c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump');
    });
  }
  function renderDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('il-cart-inner'), cur = document.getElementById('il-cart-inner');
    if (fresh && cur) { cur.replaceWith(fresh); setCount(fresh.getAttribute('data-count')); wishPaint(); }
  }
  function cartPost(url, body) {
    body.sections = SECTION;
    body.sections_url = window.location.pathname;
    return fetch(url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  window.ilCartRefresh = function () {
    return fetch(CFG.root + '?section_id=' + SECTION).then(function (r) { return r.text(); }).then(function (h) { renderDrawer(h); });
  };

  /* Add to cart: every product form with data-atc.
     The pressed button shows a spinner at once, and the cart drawer opens straight away
     with a progress line, so the shopper gets feedback while Shopify adds the item. */
  function busy(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-loading', on);
    if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-atc]');
    if (!form) return;
    e.preventDefault();
    var btn = (e.submitter && e.submitter.type === 'submit') ? e.submitter : (form.querySelector('[type="submit"]') || (form.id && document.querySelector('[type="submit"][form="' + form.id + '"]')));
    if (btn && btn.classList.contains('is-loading')) return;
    busy(btn, true);
    var drawer = document.getElementById('il-cart');
    var inDrawer = !!form.closest('#il-cart');
    var instant = hasDrawer() && !inDrawer;
    if (hasDrawer()) drawer.classList.add('is-adding');
    if (instant) openPanel('il-cart');
    var fd = new FormData(form);
    if (hasDrawer()) { fd.append('sections', SECTION); fd.append('sections_url', window.location.pathname); }
    fetch(CFG.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        document.dispatchEvent(new CustomEvent('il:cart:added', { detail: res }));
        if (hasDrawer() && res.sections) {
          renderDrawer(res.sections[SECTION]);
          if (inDrawer) toast('Added to cart');
        } else {
          fetch(CFG.cartUrl + '.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
          toast('Added to cart');
        }
        if (btn) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1600); }
      })
      .catch(function (err) {
        if (instant && current === drawer) closePanel(true);
        toast((err && (err.description || err.message)) || 'Could not add to cart');
      })
      .finally(function () { busy(btn, false); if (drawer) drawer.classList.remove('is-adding'); });
  });

  /* Drawer interactions: quantity, remove, discount codes */
  function lineChange(key, qty, row) {
    if (row) row.classList.add('is-busy');
    return cartPost(CFG.cartChange, { id: key, quantity: qty })
      .then(function (res) { renderDrawer(res.sections && res.sections[SECTION]); })
      .catch(function (err) { if (row) row.classList.remove('is-busy'); toast((err && err.description) || 'Could not update cart'); });
  }
  function applyCodes(codes, tried) {
    var inner = document.getElementById('il-cart-inner');
    if (inner) inner.classList.add('is-busy');
    return cartPost(CFG.cartUpdate, { discount: codes.join(',') })
      .then(function (res) {
        renderDrawer(res.sections && res.sections[SECTION]);
        if (tried) {
          var ok = (res.discount_codes || []).some(function (d) { return d.code.toUpperCase() === tried.toUpperCase() && d.applicable; });
          var msg = document.getElementById('il-code-msg');
          if (msg) { msg.hidden = false; msg.className = 'il-coupon-msg' + (ok ? '' : ' is-error'); msg.textContent = ok ? tried.toUpperCase() + ' applied' : tried.toUpperCase() + ' is not valid for this cart'; }
          if (ok) toast(tried.toUpperCase() + ' applied');
        }
      })
      .catch(function () { toast('Could not apply the code'); });
  }
  function currentCodes() {
    var inner = document.getElementById('il-cart-inner');
    return inner && inner.getAttribute('data-codes') ? inner.getAttribute('data-codes').split(',').filter(Boolean) : [];
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-line-qty]'), rm = e.target.closest('[data-line-rm]'), ap = e.target.closest('[data-apply-code]'), rc = e.target.closest('[data-rm-code]');
    if (q) { lineChange(q.getAttribute('data-key'), Math.max(0, +q.getAttribute('data-line-qty')), q.closest('.il-line')); }
    if (rm) { e.preventDefault(); lineChange(rm.getAttribute('data-key'), 0, rm.closest('.il-line')).then(function () { toast('Item removed'); }); }
    if (ap) { var c = ap.getAttribute('data-apply-code'), l = currentCodes(); if (l.indexOf(c) < 0) l.push(c); applyCodes(l, c); }
    if (rc) { var r = rc.getAttribute('data-rm-code'); applyCodes(currentCodes().filter(function (x) { return x.toUpperCase() !== r.toUpperCase(); })); }
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-code-form]');
    if (!f) return;
    e.preventDefault();
    var v = (f.querySelector('input').value || '').trim();
    if (!v) return;
    var l = currentCodes(); if (l.indexOf(v) < 0) l.push(v);
    applyCodes(l, v);
  });
  document.addEventListener('change', function (e) {
    var n = e.target.closest('[data-cart-note]');
    if (n) fetch(CFG.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: n.value }) });
  });

  /* =========================================================
     PREDICTIVE SEARCH  (/search/suggest.json)
     ========================================================= */
  var sInput = $('#il-search-input'), sDefault = $('#il-search-default'), sResults = $('#il-search-results');
  if (sInput && CFG.predictive) {
    var sTimer, ctrl;
    var hl = function (text, q) {
      var out = esc(text);
      q.split(/\s+/).filter(Boolean).forEach(function (t) { out = out.replace(new RegExp('(' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '<mark>$1</mark>'); });
      return out;
    };
    var icon = function (name) { var t = document.getElementById('il-ic-' + name); return t ? t.innerHTML : ''; };
    var run = function () {
      var q = sInput.value.trim();
      if (!q) { sDefault.hidden = false; sResults.hidden = true; return; }
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      var url = CFG.suggestUrl + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (d) {
        var res = (d.resources && d.resources.results) || {}, P = res.products || [], C = res.collections || [], Q = res.queries || [];
        var h = '<div class="il-search__grid"><div>';
        if (Q.length) h += '<p class="il-search__label">Suggestions</p><div class="il-sugg-list">' + Q.map(function (s) { return '<a href="' + s.url + '">' + icon('search') + '<span>' + hl(s.text, q) + '</span></a>'; }).join('') + '</div>';
        if (C.length) h += '<p class="il-search__label' + (Q.length ? ' il-mt' : '') + '">Collections</p><div class="il-sugg-list">' + C.map(function (c) { return '<a href="' + c.url + '">' + icon('arrow') + '<span>' + hl(c.title, q) + '</span></a>'; }).join('') + '</div>';
        if (!Q.length && !C.length) h += '<p class="il-search__empty">No suggestions for &ldquo;' + esc(q) + '&rdquo;</p>';
        h += '</div><div><p class="il-search__label">Products</p>';
        h += P.length ? '<div class="il-sprod-list">' + P.map(function (p) {
          var src = (p.featured_image && p.featured_image.url) || p.image || '';
          if (src) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
          var price = p.price ? money(Math.round(parseFloat(p.price) * 100)) : '';
          return '<a class="il-sprod" href="' + p.url + '">' + (src ? '<img src="' + src + '" alt="" width="52" height="69" loading="lazy">' : '<span></span>') + '<div><div class="il-sprod__t">' + hl(p.title, q) + '</div><div class="il-sprod__p">' + price + '</div></div></a>';
        }).join('') + '</div>' : '<p class="il-search__empty">No products found.</p>';
        h += '<a class="il-link il-mt" href="' + CFG.searchUrl + '?q=' + encodeURIComponent(q) + '&type=product">View all results for &ldquo;' + esc(q) + '&rdquo;</a></div></div>';
        sResults.innerHTML = h; sDefault.hidden = true; sResults.hidden = false;
      }).catch(function () {});
    };
    sInput.addEventListener('input', function () { clearTimeout(sTimer); sTimer = setTimeout(run, 180); });
    $$('[data-fill-search]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); sInput.value = b.getAttribute('data-fill-search'); run(); sInput.focus(); }); });
    sInput.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown') { var a = $('a', sResults.hidden ? sDefault : sResults); if (a) { e.preventDefault(); a.focus(); } } });
  }

  /* =========================================================
     PAGINATION: load more + infinite scroll (Section Rendering API)
     The page number stays in the URL (?page=N) so a reload, a shared
     link or the back button returns to the same place in the list.
     ========================================================= */
  function pageOf(href) { try { return parseInt(new URL(href, location.href).searchParams.get('page'), 10) || 1; } catch (e) { return 1; } }
  function setPageInUrl(n) {
    try {
      var u = new URL(location.href);
      if (n > 1) u.searchParams.set('page', n); else u.searchParams.delete('page');
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }
  function fetchGrid(href, sec, gridId) {
    var url = href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sec.getAttribute('data-section');
    return fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return { doc: doc, grid: doc.getElementById(gridId) };
    });
  }
  function initPrev(scope) {
    $$('[data-paginate-prev]', scope).forEach(function (box) {
      if (box.ilPrev) return; box.ilPrev = true;
      var grid = document.getElementById(box.getAttribute('data-grid'));
      var sec = box.closest('[data-section]');
      box.addEventListener('click', function (e) {
        var a = e.target.closest('[data-prev-page]');
        if (!a || !grid || !sec) return;
        e.preventDefault();
        if (a.classList.contains('is-loading')) return;
        a.classList.add('is-loading');
        fetchGrid(a.href, sec, grid.id).then(function (res) {
          var before = document.documentElement.scrollHeight;
          if (res.grid) {
            var frag = document.createDocumentFragment();
            Array.prototype.slice.call(res.grid.children).forEach(function (c) { frag.appendChild(c); });
            grid.insertBefore(frag, grid.firstChild);
          }
          window.scrollBy(0, document.documentElement.scrollHeight - before);
          var nb = res.doc.querySelector('[data-paginate-prev]');
          if (nb) { box.innerHTML = nb.innerHTML; } else { box.remove(); }
          ilLazy(grid); wishPaint();
        }).catch(function () { a.classList.remove('is-loading'); });
      });
    });
  }
  function initPaginate(scope) {
    initPrev(scope);
    $$('[data-paginate]', scope).forEach(function (box) {
      if (box.ilPag) return; box.ilPag = true;
      var grid = document.getElementById(box.getAttribute('data-grid'));
      var sec = box.closest('[data-section]');
      var loading = false;
      function load() {
        var a = $('[data-next-page]', box);
        if (!a || loading || !grid || !sec) return;
        loading = true; a.classList.add('is-loading');
        var page = pageOf(a.href);
        fetchGrid(a.href, sec, grid.id).then(function (res) {
          var g = res.grid, nb = res.doc.querySelector('[data-paginate]');
          if (g) Array.prototype.slice.call(g.children).forEach(function (c) { c.classList.add('il-fade'); grid.appendChild(c); });
          if (nb) { box.innerHTML = nb.innerHTML; } else { box.remove(); }
          setPageInUrl(page);
          ilLazy(grid); wishPaint();
          loading = false;
          if (box.getAttribute('data-paginate') === 'infinite') watch();
        }).catch(function () { loading = false; a.classList.remove('is-loading'); });
      }
      box.addEventListener('click', function (e) { if (e.target.closest('[data-next-page]')) { e.preventDefault(); load(); } });
      var io;
      function watch() {
        if (box.getAttribute('data-paginate') !== 'infinite' || !('IntersectionObserver' in window)) return;
        if (io) io.disconnect();
        io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) load(); }, { rootMargin: '600px 0px' });
        io.observe(box);
      }
      watch();
    });
  }
  initPaginate(document);
  window.ilInit = function (scope) { ilLazy(scope); initTabs(scope); initRails(scope); initPaginate(scope); wishPaint(); };

  /* =========================================================
     LAZY VIDEO  (self-hosted + YouTube/Vimeo facade)
     ========================================================= */
  var vids = $$('video[data-lazy-video]');
  if (vids.length && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (!x.isIntersecting) return;
        var v = x.target;
        $$('source[data-src]', v).forEach(function (s) { s.src = s.getAttribute('data-src'); s.removeAttribute('data-src'); });
        v.load(); if (v.hasAttribute('data-autoplay')) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        vio.unobserve(v);
      });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { vio.observe(v); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-embed]');
    if (!b) return;
    var f = document.createElement('iframe');
    f.src = b.getAttribute('data-embed');
    f.allow = 'autoplay; encrypted-media; picture-in-picture';
    f.allowFullscreen = true;
    f.title = b.getAttribute('aria-label') || 'Video';
    b.parentNode.replaceChild(f, b);
  });

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-hoist]', e.target).forEach(function (d) { $$('body > [id="' + d.id + '"]').forEach(function (o) { if (o !== d) o.remove(); }); });
    hoistMenu(); window.ilInit(e.target);
  });
})();
